import { MAX_BUZZED } from "constants/constants";
import {
  playBuzzSound,
  playFocusCallSound,
  playUnFocusCallSound,
  stopBuzzSound,
} from "helpers/sounds";
import {
  sendBuzz,
  sendMove,
  sendMovedOther,
} from "slices/channels/spaceChannelSlice";
import { dragActive, forcedMove } from "./spaceDrag";
import {
  drawBuzzed,
  drawDeviceStatus,
  drawFocus,
  drawShout,
  drawTalking,
  moveCircle,
  drawLocked,
} from "./spaceDraws";
import {
  calcOneD2M,
  deleteMedia2Change,
  handleMediaMagnitude,
  checkMedia2Change,
} from "./spaceMediaPhysics";
import { setNewPerson } from "./spaceSetUp";
import { receivedFPS, setreceivedFPS } from "./spaceTest";
import { hpxToPcnt, wpxToPcnt, xPcntToPx, yPcntToPx } from "./spaceUtil";
import {
  avatarCircle,
  myCircle,
  myLuid,
  people,
  setGraphicLockedValue,
  SPACEBOX,
  mediaRange,
} from "./spaceVars";

export function sendMyMove(xPx, yPx) {
  sendMove(wpxToPcnt(xPx), hpxToPcnt(yPx));
}
export function signalSendOtherMove(xPx, yPx, luid) {
  // setTimeout(() => {
  sendMovedOther(wpxToPcnt(xPx), hpxToPcnt(yPx), luid);
  // }, 3000);
}

export function handleMoves(moves) {
  if (!people[myLuid]) return;
  window.efs_debug && window.log("HANDLING MOVES");
  setreceivedFPS(receivedFPS + 1);
  let myX = people[myLuid].x;
  let myY = people[myLuid].y;
  // debugger;
  for (var luid in moves) {
    if (people[luid]) {
      if (luid !== myLuid) {
        handlePersonMove(
          myX,
          myY,
          xPcntToPx(moves[luid][0]),
          yPcntToPx(moves[luid][1]),
          luid
        );
      }
    } else {
      window.efs_debug &&
        window.log("LUID does not exist yet in people: " + luid);
      window.efs_debug &&
        window.log("People now: " + JSON.stringify(people, null, 4));
    }
  }
}

// For When Someone Moves Me
export function handleMoveOther(luid, x, y) {
  if (luid === myLuid && !dragActive && myCircle)
    forcedMove(xPcntToPx(x), yPcntToPx(y));
}

export function handlePersonMove(myX, myY, x, y, luid) {
  calcOneD2M(myX, myY, x, y, luid);
  people[luid].x = x;
  people[luid].y = y;
  checkMedia2Change(luid);
  moveCircle(luid, x, y);
}

export function graphicRemoteJoined(person) {
  graphicRemoteLeft(person.luid); // need to delete old circle in case they are rejoining
  setNewPerson(person);
}

export function graphicUpdateDevices(luid, mic, screen, cam) {
  drawDeviceStatus(luid, mic, screen, cam);
}

export function graphicRemoteLeft(luid) {
  if (people[luid]) {
    deleteMedia2Change(luid);
    delete people[luid];
  }
  if (avatarCircle[luid]) {
    SPACEBOX.removeChild(avatarCircle[luid]);
    delete avatarCircle[luid];
  }
}

export function graphicShout(luid, value) {
  people[luid].shout = value;
  if (luid !== myLuid) checkMedia2Change(luid);
  else drawShout(luid, value);
}

export function graphicPinnedShare(luid, value) {
  people[luid].pinnedShare = value;
  if (luid !== myLuid) checkMedia2Change(luid);
}

export function graphicPersonLocked(luid, value) {
  people[luid].locked = value;
  drawLocked(luid, value);
  if (myLuid === luid) setGraphicLockedValue(value);
}

export function graphicTalking(luid, value) {
  drawTalking(luid, value);
}

window.graphicShout = graphicShout;

export function graphicFocus(luid, value) {
  people[luid].focus = value;
  drawFocus(luid, value);

  if (people[luid]?.d2me < mediaRange) {
    if (value) playFocusCallSound();
    else playUnFocusCallSound();
  }

  if (luid !== myLuid && avatarCircle[luid]) {
    if (value) {
      avatarCircle[luid].onclick = (e) => {
        if (
          avatarCircle[luid] &&
          people[luid] &&
          people[luid].buzzed < MAX_BUZZED
        ) {
          playBuzzSound(luid);
          sendBuzz(luid);
        }
      };
    } else {
      people[luid].buzzed = 0;
      avatarCircle[luid].onclick = null;
      stopBuzzSound(luid);
      drawBuzzed(luid, 0);
    }
  } else if (avatarCircle[luid] && !value) {
    stopBuzzSound(luid);
  }
}

export function graphicBuzzed(luid, value) {
  people[luid].buzzed = value;
  drawBuzzed(luid, value);
  if (
    luid !== myLuid &&
    avatarCircle[luid] &&
    (value >= MAX_BUZZED || value === 0)
  )
    avatarCircle[luid].onclick = null;
}

export function handleNewPersonMagnitude(luid) {
  if (people[luid])
    handleMediaMagnitude(
      luid,
      people[luid].d2me,
      people[luid].shout,
      people[luid].pinnedShare
    );
}
